import { createTable, Link as LinkMagik, Pagination } from "@inmagik/magik-ui"
import { FiltersBase, Tag } from "../../types"
import { Link } from "react-router-dom"
import { useMemo } from "react"
import { PAGE_SIZE } from "../../constants"

const Table = createTable<Tag>()

export function TableTags({
  tags,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  tags: Tag[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {
  const numPages = useMemo(() => {
    if (!tags) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [tags, count])

  return (
    <Table
      data={tags}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Column
        title="Nome"
        name="nome"
        sortable
        width="minmax(max-content, 1fr)"
        render={(tag) => (
          <Link to={`/tags/tags/${tag.id}`}>
            <LinkMagik className="text-dark">{tag.nome}</LinkMagik>
          </Link>
        )}
        stickyLeft
      />
      <Table.Column
        title="Tipologia"
        name="tipologia"
        sortable
        width="minmax(max-content, 1fr)"
        render={(tag) => tag.tipologia}
      />
      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} tags
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
